var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStats = function SvgStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Stats_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Stats_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 32,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.382 7v3.073h5.51l-8.583 8.581-6.145-6.145L.86 22.813l2.172 2.172 8.132-8.131 6.145 6.145 10.754-10.754v5.51h3.073V7H20.382Z",
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Stats_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B7BFC8",
    d: "M0 0h32v32H0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Stats_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export { SvgStats as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyNDI2XzYwNTcwOCkiPgo8bWFzayBpZD0ibWFzazBfMTI0MjZfNjA1NzA4IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSI3IiB3aWR0aD0iMzIiIGhlaWdodD0iMTgiPgo8cGF0aCBkPSJNMjAuMzgxOSA3VjEwLjA3MjZIMjUuODkxMUwxNy4zMDkzIDE4LjY1NDRMMTEuMTY0MSAxMi41MDkyTDAuODYwMTA3IDIyLjgxMzFMMy4wMzI0NCAyNC45ODU1TDExLjE2NDEgMTYuODUzOEwxNy4zMDkzIDIyLjk5OUwyOC4wNjM0IDEyLjI0NDlWMTcuNzU0MUgzMS4xMzZWN0gyMC4zODE5WiIgZmlsbD0iYmxhY2siLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzEyNDI2XzYwNTcwOCkiPgo8cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9IiNCN0JGQzgiLz4KPC9nPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEyNDI2XzYwNTcwOCI+CjxyZWN0IHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";